import H5 from '@/h5/mobile'
import Index from '@/h5/index'
import Download from '@/h5/downloadH5'
import Product from '@/h5/productH5'
import ProductAuto from '@/h5/productautoH5'
import ProductWx from '@/h5/productwxH5'
import contactUs from '@/h5/contactUsH5'
import pos from '@/h5/posH5'
import goBei from '@/h5/goBeiH5'
import diBei from '@/h5/diBeiH5'
import support from '@/h5/supportH5'
import ticketManagement from '@/components/ticketManagement/ticketManagement'





export const h5Routes = [{
    path: '/',
    redirect: "/h5",
}, {
    path: '/ticketManagement',
    name: 'ticketManagement',
    component: ticketManagement,
}, {
    path: '/h5',
    name: 'h5',
    component: H5,
    redirect: "/h5index",
    children: [{
        path: '/h5index',
        name: 'h5index',
        component: Index,
    },
    {
        path: 'h5download',
        name: 'h5download',
        component: Download,
    },
    {
        path: 'h5product',
        name: 'h5product',
        component: Product,
    },
    {
        path: 'h5productauto',
        name: 'h5productauto',
        component: ProductAuto,
    },
    {
        path: 'productwxH5',
        name: 'productwxH5',
        component: ProductWx,
    },
    {
        path: 'h5contactus',
        name: 'h5contactus',
        component: contactUs,
    },

    {
        path: 'h5pos',
        name: 'h5pos',
        component: pos,
    },
    {
        path: 'h5goBei',
        name: 'h5goBei',
        component: goBei,
    },
    {
        path: 'h5diBei',
        name: 'h5diBei',
        component: diBei,
    },
    {
        path: 'h5support',
        name: 'h5support',
        component: support,
    }
    ]
}]



// WEBPACK FOOTER //
// ./src/router/h5.js